import React, { useState, useContext } from "react";
import Input from "../parts/Input";
import Controls from "../parts/Controls";
import List from "../parts/List";
import SelectWithSearch from "../parts/SelectWithSearch";
import { useSelector } from "react-redux";
import { removeDecimal } from "../../apis/utils";
import coinLogos from "../../assets/images/currency-icons/coinLogos.js";
import { BigNumber, ethers } from "ethers";
import { Web3Context } from "../../contexts/Web3Context";
import axios from "axios";
import CrossCloseButton from "../parts/CrossCloseButton";
import InfoButton from "../../partials/Form/InfoButton";
import ReactTooltip from "react-tooltip";
import { useDispatch } from "react-redux";
import InfoButtonMobile from "../../partials/Form/InfoButtonMobile";
import MaxPopup from "../Max";

export default function ({ page, data, list }) {
   const dispatch = useDispatch();
  const Swal = require("sweetalert2");
  let web3Context = useContext(Web3Context);
  const asset = useSelector((state) => state.modal.data.asset);
  const [formData, setFormData] = data;

  const [limit, setLimit] = useState("0");
  const [borrowing, setBorrowing] = useState(false);
  const [showMaxPopup, setShowMaxPopup] = useState(false);
  const [repaying, setRepaying] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [approving, setApproving] = useState(false);

  const changeHandler = (e, value) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const toogleForm = (value) => {
    setShowForm(value);
  };

  const toggleMaxPopup = () => {
    setShowMaxPopup(!showMaxPopup);
  };

  const setMaxRepay = () => {
    setFormData({
                ...formData,
                value:
                  page === "Borrow"
                    ? limit
                    : asset.contract.address !=
                      "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
                    ? ethers.utils.formatEther(asset.borrowBalance)
                    : ethers.utils.formatUnits(asset.borrowBalance, 6),
              })
  }

  const selectHandler = async (callateral) => {
    let availCollat = callateral.availableCollateral
      .mul(10000)
      .div(callateral.collatRatio);

    let maxBorrow =
      await web3Context.web3.uniswapOracleFactoryContract.viewUnderlyingAssetPriceOfwETH(
        asset.mmi.address,
        availCollat
      );

    if (
      asset.contract.address == "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
    ) {
      maxBorrow = ethers.utils.formatUnits(maxBorrow, 6);

      setLimit(maxBorrow.toString());
    } else {
      maxBorrow = ethers.utils.formatEther(maxBorrow);

      setLimit(maxBorrow.toString());
    }

    setFormData({
      ...formData,
      callateral,
    });
  };

  const handleBorrow = async (e) => {
    e.preventDefault();
    // inform user if web3 not initialized
    if (web3Context.currentAccountAddress == "") {
      // alert("You are not connected. Connect and try again.");
      Swal.fire({
        text: "You are not connected. Connect and try again.",
        icon: "info",
        confirmButtonText: "Ok",
      });
      return;
    }
    if (formData.callateral.id == 0) {
      // alert("Please select a collateral.");
      Swal.fire({
        text: "Please select a collateral.",
        icon: "info",
        confirmButtonText: "Ok",
      });
      return;
    }
    if (!asset.borrowBalance.isZero()) {
      // alert("Please repay loan before making another borrow.");
      Swal.fire({
        text: "Please repay loan before making another borrow.",
        icon: "info",
        confirmButtonText: "Ok",
      });
      return;
    }

    let requestedBorrow =
      formData.value === ""
        ? ethers.utils.parseEther("0")
        : ethers.utils.parseEther(formData.value.toString());

    let borrowLimit = ethers.utils.parseEther(limit);

    let liquidity = asset.liquidity;

    if (
      asset.contract.address == "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
    ) {
      requestedBorrow = ethers.utils.parseUnits(formData.value.toString(), 6);
      borrowLimit = ethers.utils.parseUnits(limit.toString(), 6);
    }

    if (liquidity.lt(requestedBorrow)) {
      // ("Insufficient liquidity.");
      Swal.fire({
        text: "Insufficient liquidity.",
        icon: "info",
        confirmButtonText: "Ok",
      });
      return;
    }
    // must have enough collateral
    if (borrowLimit.lt(requestedBorrow)) {
      // alert("Insufficient collateral.");
      Swal.fire({
        text: "Insufficient collateral.",
        icon: "info",
        confirmButtonText: "Ok",
      });
      return;
    }
    try {
      setBorrowing(true);
      let borrowTx = await asset.mmi.borrow(
        requestedBorrow,
        formData.callateral.alr.address
      );
      await borrowTx.wait();

      const urlSet =
        "https://us-central1-rasko-backend.cloudfunctions.net/borrow" +
        "?account=" +
        web3Context.currentAccountAddress +
        "&mmi=" +
        asset.mmi.address;
      await axios.post(urlSet);
    } catch (error) {
      setBorrowing(false);
      return;
    }
    Swal.fire({
      text: "Borrow successful.",
      icon: "success",
      confirmButtonText: '<a href="/trade">OK</a>',
    });
    setBorrowing(false);
  };

  const handleRepay = async (e) => {
    e.preventDefault();
    if (formData.value === "" || formData.value == 0) {
      // alert("Enter a valid number.");
      Swal.fire({
        text: "Enter a valid number.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    const accountBalance = asset.balance;
    let requestedRepay =
      formData.value === ""
        ? ethers.utils.parseEther("0")
        : asset.contract.address == "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
        ? ethers.utils.parseUnits(formData.value.toString(), 6)
        : ethers.utils.parseEther(formData.value.toString());

    if (
      asset.contract.address == "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
    ) {
      if (requestedRepay.toString() == asset.borrowBalance.toString()) {
        requestedRepay = 0;
      }
    } else {
      if (requestedRepay.toString() == asset.borrowBalance.toString()) {
        requestedRepay = 0;
      }
    }

    // inform user if web3 not initialized
    if (web3Context.currentAccountAddress == "") {
      // alert("You are not connected. Connect and try again.");
      Swal.fire({
        text: "You are not connected. Connect and try again.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    // must have enough balance
    if (accountBalance.lt(requestedRepay)) {
      // alert("Insufficient token balance.");
      Swal.fire({
        text: "Insufficient token balance.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    // if repaid too much alert user
    if (asset.borrowBalance.lt(requestedRepay)) {
      // alert("Warning: Repay amount is larger than amount borrowed.");
      Swal.fire({
        text: "Warning: Repay amount is larger than amount borrowed.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    try {
      setRepaying(true);
      let repayTx = await asset.mmi.repay(requestedRepay);
      await repayTx.wait();

      const urlSet =
        "https://us-central1-rasko-backend.cloudfunctions.net/repay" +
        "?account=" +
        web3Context.currentAccountAddress +
        "&mmi=" +
        asset.mmi.address;
      await axios.post(urlSet);
    } catch (error) {
      setRepaying(false);
      return;
    }
    Swal.fire({
      text: "Repay successful.",
      icon: "success",
      confirmButtonText: '<a href="/trade">OK</a>',
    });
    setRepaying(false);
  };

  const handleApprove = async (e) => {
    e.preventDefault();
    try {
      setApproving(true);
      const approveTx = await asset.contract.approve(
        asset.mmi.address,
        ethers.constants.MaxUint256
      );
      await approveTx.wait();
    } catch (error) {
      setApproving(false);
      return;
    }
    /* alert("Approve successful."); */
     Swal.fire({
      text: "Approve successful.",
      icon: "success",
      confirmButtonText: '<a href="/trade">OK</a>',
    });
    setApproving(false);
    window.location.reload();
    return;
  };

  return (
    <form
      className="modal-form modal-borrow__form"
      style={{ minHeight: showForm ? "370px" : "inherit" }}
    >
      <CrossCloseButton className="custom-cross-btn_black close_btn" />
      <MaxPopup showPopup={showMaxPopup} togglePopup={toggleMaxPopup} onClick={setMaxRepay} />
      <div className="modal-borrow__item">
        <div className="modal-borrow__item-title">
          <span style={{ display: "inline-flex" }}>
            I Want to{" "}
            {page === "Borrow" ? (
              "Borrow"
            ) : (
              <>
                Repay &nbsp;{" "}
                <InfoButton marginBottom={10} textAlign="left" posX="left">
                  Repay to payback your loan.
                </InfoButton>{" "}
                <InfoButtonMobile text="Repay to payback your loan." />
              </>
            )}{" "}
          </span>
          <span className="mb_gray">
            Limit:{" "}
            {page === "Borrow"
              ? limit
              : asset.contract.address !=
                "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
              ? removeDecimal(
                  ethers.utils.formatEther(asset.borrowBalance) * 1000
                ) / (1000).toString()
              : removeDecimal(
                  ethers.utils.formatUnits(asset.borrowBalance, 6) * 1000
                ) / (1000).toString()}{" "}
            {asset.name}
          </span>
        </div>
        <div className="modal-form__field modal-borrow__field">
          <Input
            type="float"
            placeholder="0"
            name="value"
            onChange={changeHandler}
            maxEnable
            value={formData.value}
            
            maxHandler={page === "Borrow" ?  () =>
               setFormData({
                ...formData,
                value: limit
              }) : () => setShowMaxPopup(true)}

          />
          <div className="modal-form__curr modal-borrow__curr">
            {asset.name}
          </div>
        </div>
      </div>

      {page === "Borrow" && (
        <>
          <div className="modal-borrow__item modal-borrow__item_mt21">
            <div className="modal-borrow__item-title">
              <span style={{ display: "inline-flex" }}>
                Select Collateral &nbsp;{" "}
                <InfoButton marginBottom={10} textAlign="left" posX="left">
                  Category 1 can borrow Categories 1, 2, 3, 4. Category 2 can
                  borrow Categories 2, 3, 4. Category 3 can borrow Categories 3
                  and 4. Category 4 can borrow Category 4.
                </InfoButton>
                <InfoButtonMobile text="Category 1 can borrow Categories 1, 2, 3, 4. Category 2 can borrow Categories 2, 3, 4. Category 3 can borrow Categories 3 and 4. Category 4 can borrow Category 4." />
              </span>
            </div>
            <div className="modal-form__field">
              <SelectWithSearch
                active={formData.callateral}
                items={list}
                onChange={selectHandler}
                toogleForm={toogleForm}
              />
            </div>
          </div>
          {/* <div className="modal-borrow__subtext">
                    <span>LR Link Balance:</span>
                    <span>https://link</span>
                </div> */}
        </>
      )}

      <div className="modal-borrow__controls">
        <button
          onClick={
            page === "Borrow"
              ? handleBorrow
              : asset.allowance > ethers.utils.parseEther("10000")
              ? handleRepay
              : handleApprove
          }
          style={{ margin: "10px auto 0" }}
          className="button-b button-b_sm modal-controls__btn"
          disabled={borrowing || repaying || approving}
        >
          {page === "Borrow"
            ? borrowing
              ? "Borrowing..."
              : "Borrow"
            : repaying
            ? "Repaying..."
            : asset.allowance > ethers.utils.parseEther("10000")
            ? "Repay"
            : approving
            ? "Approving..."
            : "Approve"}
        </button>
      </div>
    </form>
  );
}
